import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { cartReducer } from './store/reducers/cart.reducer';
import { CartEffects } from './store/cart.effect';
import { CartServiceV2 } from './services/cart-v2.service';
import { CartEventsService } from './services/cart-events.service';

@NgModule({
  imports: [
    NgbModule,
    FormsModule,
    CommonModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreModule.forFeature('cart', cartReducer),
    EffectsModule.forFeature([CartEffects])
  ],
  declarations: [],
  exports: []
})
export class CieWebCartModule {
  static forRoot(): ModuleWithProviders<CieWebCartModule> {
    return {
      ngModule: CieWebCartModule,
      providers: [
        CartServiceV2,

        CartEffects,
        CartEventsService,
      ]
    };
  }
}
